export function isTouchEvent(e: React.TouchEvent<HTMLCanvasElement> | React.MouseEvent<HTMLCanvasElement>) : e is React.TouchEvent<HTMLCanvasElement> {
    return !!(e as React.TouchEvent<HTMLCanvasElement>).touches ;
}
